import { Module, VuexModule, Mutation, Action } from "vuex-module-decorators";
import { City } from "@/models/City";
import { db } from "@/api/firebase";
import ErrorService from "@/utils/ErrorService";
import Vue from "vue";
import { orderBy } from "lodash";
import ErrorsCity from "@/utils/ErrorsCity";

@Module({ namespaced: true })
export default class CityStore extends VuexModule {
  city: City[] = [];
  singleCity = {} as City;
  clonedCity = {} as City;
  citySlug = "";
  isEditing = false;

  @Mutation
  setCities(city: City[]): void {
    this.city = city;
  }
  @Mutation
  setCitySlug(city: string): void {
    this.citySlug = city;
  }

  @Mutation
  currentlyEditing(value: boolean): void {
    this.isEditing = value;
  }
  @Mutation
  setSingleCity(city: City): void {
    this.singleCity = city;
  }
  @Mutation
  setClonedCity(city: City): void {
    this.clonedCity = city;
  }

  @Action({ rawError: true })
  public async getCities(): Promise<void> {
    try {
      await db.ref("cities").off();
      const dbRef = await db.ref("cities");
      dbRef.on("child_added", (data) => {
        const city = {} as City;
        city.name = data.val().name;
        city.is_edit = data.val().is_edit;
        city.slug = data.val().slug;
        city.centre_point = data.val().centre_point;
        city.country = data.val().country;
        this.city.push(city);
      });
      dbRef.on("child_changed", (data) => {
        const results = this.city.findIndex((x: City) => x.slug === data.key);
        const city = {} as City;
        city.name = data.val().name;
        city.is_edit = data.val().is_edit;
        city.slug = data.val().slug;
        city.centre_point = data.val().centre_point;
        city.country = data.val().country;
        Vue.set(this.city, results, city);
      });
      dbRef.on("child_removed", (data) => {
        const results = this.city.findIndex((x: City) => x.slug === data.key);
        Vue.delete(this.city, results);
      });
    } catch (error) {
      ErrorService.onError(error);
      return Promise.reject();
    }
  }
  @Action
  public async insertNewCity(city: City): Promise<string> {
    try {
      db.ref("cities/" + city.slug).set(city);
      return "success";
    } catch (error) {
      console.log(error);
      return "failed";
    }
  }

  @Action({ rawError: true })
  public async addEditLock(data: any): Promise<void> {
    try {
      this.context.commit("currentlyEditing", data.value);
      await db.ref("cities/" + data.slug).update({ is_edit: data.value });
    } catch (error) {
      console.log(error);
    }
  }

  @Action
  public async insertNewLocation(data: any): Promise<string> {
    try {
      db.ref("cities/" + data.city + "/locations/" + data.cityPoint.slug).set(
        data.cityPoint
      );
      return "success";
    } catch (error) {
      console.log(error);
      return "failed";
    }
  }

  @Action
  public async updateLocation(data: any): Promise<string> {
    try {
      db.ref(
        "cities/" + data.city + "/locations/" + data.cityPoint.slug
      ).update(data.cityPoint);
      return "success";
    } catch (error) {
      console.log(error);
      return "failed";
    }
  }

  @Action
  public async updateCity(cityData: City): Promise<string> {
    try {
      //Delete both issues / tzone as we don't need them updated at runtime
      delete cityData.issues;
      delete cityData.tZone;
      new ErrorsCity(cityData).checkCityErrors();
      await db.ref("cities/" + cityData.slug).update(cityData);
      return "success";
    } catch (error) {
      console.log(error);
      return "failed";
    }
  }
  @Action
  public async getSingleCity(slug: string): Promise<void> {
    try {
      await db.ref("cities/" + this.citySlug).off();
      await db.ref("cities/" + slug).on("value", (results) => {
        this.context.commit("setCitySlug", results.val().slug);
        this.context.commit("setSingleCity", results.val());
      });
    } catch (error) {
      ErrorService.onError(error);
    }
  }
  @Action
  public async getClonedCity(slug: string): Promise<void> {
    try {
      await db.ref("cities/" + slug).on("value", (results) => {
        this.context.commit("setClonedCity", results.val());
      });
    } catch (error) {
      ErrorService.onError(error);
    }
  }
  @Action
  public async deleteCity(cityData: City): Promise<string> {
    try {
      this.context.commit("currentlyEditing", false);
      await db.ref("cities/" + cityData.slug).remove();
      return "success";
    } catch (error) {
      console.log(error);
      return "failed";
    }
  }
  @Action
  public async deleteLocation(data: any): Promise<string> {
    try {
      db.ref(
        "cities/" + data.city + "/locations/" + data.locationSlug
      ).remove();
      return "success";
    } catch (error) {
      console.log(error);
      return "failed";
    }
  }

  @Action
  public async addCenterPointScript(data: City[]): Promise<void> {
    try {
      const listArray: string[] = [];
      data.forEach(async (x: City) => {
        if (
          x.locations === undefined ||
          x.locations["centre_point"] === undefined
        ) {
          if (x.locations === undefined) {
            x.locations = {
              centre_point: {
                slug: "centre_point",
                name: { en: "centre_point" },
                lat_long: {
                  latitude: x.centre_point.latitude,
                  longitude: x.centre_point.longitude,
                },
              },
            };
          }
          if (x.locations["centre_point"] === undefined) {
            x.locations["centre_point"] = {
              slug: "centre_point",
              name: { en: "centre_point" },
              lat_long: {
                latitude: x.centre_point.latitude,
                longitude: x.centre_point.longitude,
              },
            };
          }
          listArray.push(x.slug);
          await db.ref("cities/" + x.slug + "/locations/").update(x.locations);
        }
      });
      console.log("changed: " + listArray.length);
    } catch (error) {
      console.log(error);
    }
  }
}
